import { getAppContext, getAppContextCountryIso, getAppContextLanguage } from "../cookieUtils";

const ENTRY_PATH_REGEX = /^\/([^/]+)\/([^/]+)\//;

// Redirects when the entry URL's country/lang segments don't match the native app context (embedded webview).
export const alignUrlWithAppContext = (): boolean => {
  const appContext = getAppContext();
  if (!appContext) {
    return false;
  }

  const countryIso = getAppContextCountryIso();
  const language = getAppContextLanguage();
  if (!countryIso || !language) {
    return false;
  }

  const match = location.pathname.match(ENTRY_PATH_REGEX);
  const [, currentCountry, currentLanguage] = match ?? [];

  if (currentCountry?.toLowerCase() === countryIso && currentLanguage?.toLowerCase() === language) {
    return false;
  }

  const updatedPath = match
    ? location.pathname.replace(ENTRY_PATH_REGEX, `/${countryIso}/${language}/`)
    : `/${countryIso}/${language}${location.pathname}`;

  window.location.replace(`${location.origin}${updatedPath}${location.search}${location.hash}`);
  return true;
};
